import React from 'react';
import { ListViewMenu } from '~/components';
import { accountingProviders } from '~/lookups';

export default function CreditNoteAccountingActions({
  accountingSynced,
  accountingProvider,
  disabled,
  tooltip,
  Container = ListViewMenu.Item,
  onReload,
}) {
  if (!accountingSynced || !accountingProvider) return null;

  const accountingProviderName = accountingProviders[accountingProvider].name;

  return (
    <Container disabled={disabled} tooltip={tooltip} onClick={() => onReload(accountingProvider)}>
      Reload from {accountingProviderName}
    </Container>
  );
}
